"use strict";

export const setTimeoutWithCallBack = function setTimeoutWithCallBack(cb) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const timeout = setTimeout(() => void cb(), delay);
  return () => clearTimeout(timeout);
};